import { Rating } from '@/components/reui/rating'

const StarField = ({ field, value, onChange, disabled }) => (
  <Rating
    rating={typeof value === 'number' ? value : 0}
    maxRating={5}
    editable={!disabled}
    onRatingChange={(n) => onChange(n)}
    aria-label={field.label}
    className={disabled ? 'opacity-50' : undefined}
  />
)

export default StarField
